import React, { useEffect, useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './PaymentScreen.css';
import Footer from '../Footer/Footer';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
    stripeAccount: undefined,
    locale: 'en'
});


const StripePaymentForm = ({ amount, onSuccess }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [processing, setProcessing] = useState(false);
    const { state } = useLocation();

const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
        alert("Payment system is still loading. Please try again in a moment.");
        return;
    }

    setProcessing(true);

    try {
        // 1. Create Payment Intent
        const { data: { clientSecret } } = await axios.post(
            'http://localhost:3001/create-payment-intent',
            { amount },
            { 
                withCredentials: true,
                timeout: 10000
            }
        );

        // 2. Confirm Card Payment
        const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
                billing_details: {
                    name: state.address.name,
                    email: state.address.email
                },
            }
        });

        if (error) {
            console.error("Stripe error:", error);
            throw error;
        }

        if (paymentIntent.status === 'succeeded') {
            console.log("Payment succeeded:", paymentIntent);
            onSuccess();
        }
    } catch (error) {
        console.error("Payment failed:", error);
        alert(`Payment failed: ${error.message}`);
    } finally {
        setProcessing(false);
    }
};

    return (
        <form onSubmit={handleSubmit}>
            <CardElement
                options={{
                    style: {
                        base: {
                            fontSize: '16px',
                            color: '#424770',
                            '::placeholder': {
                                color: '#aab7c4',
                            },
                        },
                        invalid: {
                            color: '#9e2146',
                        },
                    },
                }}
            />
            <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={!stripe || processing}
            >
                {processing ? 'Processing...' : `Pay ₹${amount.toFixed(2)}`}
            </button>
        </form>
    );
};

function PaymentScreen() {
    const { cartItems, cartTotal, clearCart } = useCart();
    const { state } = useLocation();
    const navigate = useNavigate();
    const [paymentMethod, setPaymentMethod] = useState('card');
    const [upiId, setUpiId] = useState('');
    const [stripeLoaded, setStripeLoaded] = useState(false);



    const handleOrderSubmission = async () => {
        try {

            const { data: user } = await axios.get(
            'http://localhost:3001/auth/me', 
            { withCredentials: true }
            );

            const orderItems = cartItems.map(item => ({
                productId: item._id,
                quantity: item.quantity,
                price: item.price
            }));


            const order = {
                userEmail: user.email,
                userName: user.name,
                shippingAddress: state.address,
                items: orderItems,
                total: cartTotal,
                paymentMethod: paymentMethod,
                // paymentStatus: paymentMethod === 'cod' ? 'Pending' : 'Paid',
                // trackingStatus: 'Order Placed'
            };

            console.log("Submitting order:", order);
            console.log("Submitting order with user email:", order.userEmail);
            console.log("Order payload:", JSON.stringify(order, null, 2));

            const response = await axios.post('http://localhost:3001/orders', order, {
                withCredentials: true
            });

            console.log("Order creation response:", response.data);
            console.log("Order created with ID:", response.data._id);

            clearCart();
            navigate('/order-confirmation', {
                state: {
                    orderId: response.data._id,
                    address: state.address,
                    userName: user.name,
                }
            });
        } catch (error) {
            console.error("Order creation error:", error);
            alert("Failed to place order. Please try again.");
        }
    };

    useEffect(() => {
        stripePromise.then(() => {
            setStripeLoaded(true);
        }).catch(err => {
            console.error("Failed to load Stripe:", err)
        });
    }, []);

    return (
        <>
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>
            <div className='payment-container container py-5'>
                <h2>Payment</h2>
                <div className="row">
                    <div className="col-md-8">
                        <div className="card mb-4">
                            <div className="card-body">
                                <h5>Delivery Address</h5>
                                <p>{state.address.name}</p>
                                <p>{state.address.address}</p>
                                <p>{state.address.city}, {state.address.state} - {state.address.pincode}</p>
                                <p>Phone: {state.address.phone}</p>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <h5>Payment Method</h5>

                                <div className="payment-options">
                                    <div className="form-check mb-3">
                                        <input
                                            type="radio"
                                            className='form-check-input'
                                            name='paymentMethod'
                                            id='credit-card'
                                            checked={paymentMethod === 'card'}
                                            onChange={() => setPaymentMethod('card')}
                                        />
                                        <label className="form-check-label" htmlFor="credit-card">
                                            Credit/Debit Card
                                        </label>
                                    </div>

                                    {paymentMethod === 'card' && (
                                        stripeLoaded ? (
                                            <Elements stripe={stripePromise}>
                                                <StripePaymentForm
                                                    amount={cartTotal}
                                                    onSuccess={handleOrderSubmission}
                                                />
                                            </Elements>
                                        ) : (
                                            <div>Loading payment gateway...</div>
                                        )
                                    )}


                                    <div className="form-check mb-3">
                                        <input
                                            type="radio"
                                            className='form-check-input'
                                            name='paymentMethod'
                                            id='upi'
                                            checked={paymentMethod === 'upi'}
                                            onChange={() => setPaymentMethod('upi')}
                                        />
                                        <label className="form-check-label" htmlFor="upi">
                                            UPI
                                        </label>
                                    </div>

                                    {paymentMethod === 'upi' && (
                                        <div className="form-group mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="yourname@upi"
                                                value={upiId}
                                                onChange={(e) => setUpiId(e.target.value)}
                                            />
                                            <button
                                                className="btn btn-primary mt-2"
                                                onClick={handleOrderSubmission}
                                                disabled={!upiId}
                                            >
                                                Pay ₹{cartTotal.toFixed(2)}
                                            </button>
                                        </div>
                                    )}

                                    <div className="form-check mb-3">
                                        <input
                                            type="radio"
                                            className='form-check-input'
                                            name='paymentMethod'
                                            id='cod'
                                            checked={paymentMethod === 'cod'}
                                            onChange={() => setPaymentMethod('cod')}
                                        />
                                        <label className="form-check-label" htmlFor="cod">
                                            Cash on Delivery
                                        </label>
                                    </div>

                                    {paymentMethod === 'cod' && (
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleOrderSubmission}
                                        >
                                            Place Order (₹{cartTotal.toFixed(2)})
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="card">
                            <div className="card-body">
                                <h5>Order Summary</h5>
                                {cartItems.map(item => (
                                    <div className="d-flex justify-content-between mb-2" key={item._id}>
                                        <span>{item.title} (x{item.quantity})</span>
                                        <span>₹{(item.price * item.quantity).toFixed(2)}</span>
                                    </div>
                                ))}
                                <hr />
                                <div className="d-flex justify-content-between">
                                    <strong>Total:</strong>
                                    <strong>₹{cartTotal.toFixed(2)}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer/>
        </>
    );
}

export default PaymentScreen;